// extracted by mini-css-extract-plugin
export var betaNotice = "BetaNotice-module--betaNotice--2B0OY";
export var underConstruction = "BetaNotice-module--underConstruction--2BgfE";
export var betaNoticeContent = "BetaNotice-module--betaNoticeContent--vJnR2";
export var betaNoticeHeading = "BetaNotice-module--betaNoticeHeading--1FNJ5";
export var buttonLight = "BetaNotice-module--buttonLight--1rEIu";